import React, { useState } from "react";
import { LoadingButton } from "@mui/lab";
import {
	Box,
	Dialog,
	Button,
	Typography,
	Alert,
	AlertTitle,
} from "@mui/material";

function DeleteAdvisorModal({
	delOpen,
	setDelOpen,
	deleteApi,
	deleteMsg,
	setDeleteMsg,
	idToDelete,
	fullName,
}) {
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);

	const onConfirmHandle = async () => {
		setLoading(true);
		await deleteApi(idToDelete);
		setLoading(false);
		setOpen(true);
	};

	return (
		<>
			<Dialog
				open={delOpen}
				onClose={() => {
					setDelOpen(false);
				}}>
				<Box p={2}>
					<Typography fontSize={18}>حذف مشاور</Typography>
					<Typography fontSize={16}>آیا از حذف {fullName} اطمینان دارید؟</Typography>
					<Box mt={2}>
						<LoadingButton
							variant="contained"
							color="secondary"
							onClick={onConfirmHandle}
							sx={{ fontSize: "16px", color: "white" }}
							loading={loading}>
							حذف
						</LoadingButton>
						<Button
							variant="contained"
							sx={{ fontSize: "16px", mr: 2 }}
							onClick={() => {
								setDelOpen(false);
							}}>
							انصراف
						</Button>
					</Box>
				</Box>
			</Dialog>

			<Dialog open={open}>
				<Box className="d-flex-column" p={2}>
					{deleteMsg &&
						(deleteMsg.type ? (
							<Alert
								icon={false}
								severity={"success"}
								sx={{ alignItems: "flex-start", fontSize: "14px", mt: 0.5 }}>
								<AlertTitle sx={{ fontSize: "16px" }}>{deleteMsg.header}</AlertTitle>
								{deleteMsg.message}
							</Alert>
						) : (
							<Alert
								icon={false}
								severity={"error"}
								sx={{ alignItems: "flex-start", fontSize: "14px", mt: 0.5 }}>
								<AlertTitle sx={{ fontSize: "16px" }}>{deleteMsg.header}</AlertTitle>
								{deleteMsg.message}
							</Alert>
						))}

					{deleteMsg && (
						<Button
							variant="contained"
							sx={{ fontSize: "16px", width: "100px", mt: 1 }}
							onClick={() => {
								setOpen(false);
								setDelOpen(false);
								setDeleteMsg(null);
							}}>
							{deleteMsg.type ? "تایید" : "متوجه شدم"}
						</Button>
					)}
				</Box>
			</Dialog>
		</>
	);
}

export default DeleteAdvisorModal;
